const submitOnEnter = {
    methods: {
        addEnterListener(callback) {
            let callbackType = typeof callback
            if (callbackType !== 'function') throw new Error(`Callback must be a function, ${callbackType} given.`)
            const handler = ({keyCode}) => {
                if (keyCode !== 13) return
                callback()
            }
            document.addEventListener('keypress', handler)
            // unsubscriber
            if (!this.$options.beforeDestroy) {
                this.$options.beforeDestroy = [];
            }
          
            this.$options.beforeDestroy.push(() => {
                document.removeEventListener('keypress', handler)
            });
        }
    }
}

export default submitOnEnter